import type { Player } from '@acepoker/contract'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { UserRole } from '@/helpers/jwt'

export const useAuth = defineStore('auth', () => {
  const token = ref<string | null>(null)
  const player = ref<Player | null>(null)
  const status = ref<'idle' | 'loading' | 'loaded' | 'error'>('idle')

  const role = ref<UserRole | null>(null)
  const isAuthInvalid = ref(false)
  const isForbidden = ref(false)

  const isLoggedIn = computed(() => !!token.value && !!player.value?.email)
  const isGuest = computed(() => !!token.value && !player.value?.email)

  const markAuthAsInvalid = () => {
    isAuthInvalid.value = true
  }

  const clearAuthInvalid = () => {
    isAuthInvalid.value = false
  }

  const markAsForbidden = () => {
    isForbidden.value = true
  }

  const clearForbidden = () => {
    isForbidden.value = false
  }

  return {
    token,
    player,
    status,
    role,
    isAuthInvalid,
    isForbidden,
    isLoggedIn,
    isGuest,
    markAuthAsInvalid,
    clearAuthInvalid,
    markAsForbidden,
    clearForbidden
  }
})
